import { Component, OnInit, Input } from '@angular/core';
import { MyInstitutionService, IInstitutionInfo } from '../my-institution.service';
import { IInstitution } from '../../api/models/db/institutions.schema';
import { LangService } from '../../core/lang.service';
import { IAccountType } from '../../constants/account-types';
import { DemoDataService } from '../demo-data.service';

export enum InstMngView {
  INST_INFO = 'mng-inst-info',
  ACCOUNTS = 'mng-inst-accounts',
  ALL_SESSIONS = 'all-test-sessions',
}



@Component({
  selector: 'pnel-my-institution',
  templateUrl: './pnel-my-institution.component.html',
  styleUrls: ['./pnel-my-institution.component.scss']
})
export class PnelMyInstitutionComponent implements OnInit {

  @Input() currentView : InstMngView;

  public instInfo:IInstitutionInfo;
  public InstMngView = InstMngView;

  constructor(
    public lang: LangService,
    private myInst: MyInstitutionService,
    private demoData: DemoDataService,
  ) { }

  ngOnInit() {
    this.myInst.sub().subscribe(this.updateInstInfo)
  }

  updateInstInfo = (instInfo:IInstitutionInfo) => {
    this.instInfo = instInfo;
  }

  isMeAccommCoord(){
    return this.demoData.isMeAccommCoord();
  }

  getRouterMngInstInfo ()     { return `/${this.lang.getCurrentLanguage()}/${IAccountType.TEST_ADMIN}/mng-inst-info`; }
  getRouterMngInstAccounts () { return `/${this.lang.getCurrentLanguage()}/${IAccountType.TEST_ADMIN}/mng-inst-accounts`; }
  getRouterAllTestSessions () { return `/${this.lang.getCurrentLanguage()}/${IAccountType.TEST_ADMIN}/all-test-sessions`; }

}
